/**
 * Generated by orval 🍺
 * Do not edit manually.
 * Internal API
 * OpenAPI spec version: v1
 */
import {
  useMutation,
  useQuery
} from '@tanstack/vue-query';
import type {
  DataTag,
  MutationFunction,
  QueryClient,
  QueryFunction,
  QueryKey,
  UseMutationOptions,
  UseMutationReturnType,
  UseQueryOptions,
  UseQueryReturnType
} from '@tanstack/vue-query';

import {
  toValue,
  unref
} from 'vue';
import type {
  MaybeRefOrGetter
} from 'vue';

import type {
  Profile,
  ProfileLocationOptions,
  ProfileRequestInput,
  SchemaValidationErrorResponse,
  ValidationError
} from '../../models';

import { axiosClient } from '../../../internalAxiosClient.ts';
import type { ErrorType } from '../../../internalAxiosClient.ts';




/**
 * @summary Delete Profile (Account Deletion)
 */
export const deleteProfile = (

 signal?: AbortSignal
) => {


      return axiosClient<void>(
      {url: `/profile`, method: 'DELETE', signal
    },
      );
    }




export const getDeleteProfileMutationKey = () => ['deleteProfile'] as const;

export const getDeleteProfileMutationOptions = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteProfile>>, TError,void, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof deleteProfile>>, TError,void, TContext> => {

const mutationKey = getDeleteProfileMutationKey();
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof deleteProfile>>, void> = () => {


          return  deleteProfile()
        }






  return  { mutationFn, ...mutationOptions }}

    export type DeleteProfileMutationResult = NonNullable<Awaited<ReturnType<typeof deleteProfile>>>

    export type DeleteProfileMutationError = ErrorType<void>


    /**
 * @summary Delete Profile (Account Deletion)
 */
export const useDeleteProfile = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteProfile>>, TError,void, TContext>, }
 , queryClient?: QueryClient): UseMutationReturnType<
        Awaited<ReturnType<typeof deleteProfile>>,
        TError,
        void,
        TContext
      > => {
      return useMutation(getDeleteProfileMutationOptions(options), queryClient);
    }
    /**
 * @summary Get Profile
 */
export const getProfile = (

 signal?: AbortSignal
) => {


      return axiosClient<Profile>(
      {url: `/profile`, method: 'GET', signal
    },
      );
    }




export const getGetProfileQueryKey = () => {
    return [
    'profile'
    ] as const;
    }


export const getGetProfileQueryOptions = <TData = Awaited<ReturnType<typeof getProfile>>, TError = ErrorType<void>>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getProfile>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  getGetProfileQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getProfile>>> = ({ signal }) => getProfile(signal);





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getProfile>>, TError, TData>
}

export type GetProfileQueryResult = NonNullable<Awaited<ReturnType<typeof getProfile>>>
export type GetProfileQueryError = ErrorType<void>


/**
 * @summary Get Profile
 */

export function useGetProfile<TData = Awaited<ReturnType<typeof getProfile>>, TError = ErrorType<void>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getProfile>>, TError, TData>>, }
 , queryClient?: QueryClient
 ): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetProfileQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}






/**
 * @summary Update Profile
 */
export const updateProfile = (
    profileRequestInput: MaybeRefOrGetter<ProfileRequestInput>,
 signal?: AbortSignal
) => {
      profileRequestInput = toValue(profileRequestInput);

      return axiosClient<void>(
      {url: `/profile`, method: 'PATCH',
      headers: {'Content-Type': 'application/json', },
      data: profileRequestInput, signal
    },
      );
    }




export const getUpdateProfileMutationKey = () => ['updateProfile'] as const;

export const getUpdateProfileMutationOptions = <TError = ErrorType<SchemaValidationErrorResponse | void | ValidationError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateProfile>>, TError,UpdateProfileMutationVariables, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof updateProfile>>, TError,UpdateProfileMutationVariables, TContext> => {

const mutationKey = getUpdateProfileMutationKey();
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof updateProfile>>, UpdateProfileMutationVariables> = (props) => {
          const {data} = props ?? {};

          return  updateProfile(data,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type UpdateProfileMutationResult = NonNullable<Awaited<ReturnType<typeof updateProfile>>>
    export type UpdateProfileMutationBody = ProfileRequestInput
    export type UpdateProfileMutationError = ErrorType<SchemaValidationErrorResponse | void | ValidationError>
    export type UpdateProfileMutationVariables = {data: ProfileRequestInput}

    /**
 * @summary Update Profile
 */
export const useUpdateProfile = <TError = ErrorType<SchemaValidationErrorResponse | void | ValidationError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateProfile>>, TError,UpdateProfileMutationVariables, TContext>, }
 , queryClient?: QueryClient): UseMutationReturnType<
        Awaited<ReturnType<typeof updateProfile>>,
        TError,
        UpdateProfileMutationVariables,
        TContext
      > => {
      return useMutation(getUpdateProfileMutationOptions(options), queryClient);
    }
    /**
 * @summary Get the profile's country and region options
 */
export const getProfileLocationOptions = (

 signal?: AbortSignal
) => {


      return axiosClient<ProfileLocationOptions>(
      {url: `/profile/location_options`, method: 'GET', signal
    },
      );
    }




export const getGetProfileLocationOptionsQueryKey = () => {
    return [
    'profile','location_options'
    ] as const;
    }


export const getGetProfileLocationOptionsQueryOptions = <TData = Awaited<ReturnType<typeof getProfileLocationOptions>>, TError = ErrorType<void>>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getProfileLocationOptions>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  getGetProfileLocationOptionsQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getProfileLocationOptions>>> = ({ signal }) => getProfileLocationOptions(signal);





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getProfileLocationOptions>>, TError, TData>
}

export type GetProfileLocationOptionsQueryResult = NonNullable<Awaited<ReturnType<typeof getProfileLocationOptions>>>
export type GetProfileLocationOptionsQueryError = ErrorType<void>


/**
 * @summary Get the profile's country and region options
 */

export function useGetProfileLocationOptions<TData = Awaited<ReturnType<typeof getProfileLocationOptions>>, TError = ErrorType<void>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getProfileLocationOptions>>, TError, TData>>, }
 , queryClient?: QueryClient
 ): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetProfileLocationOptionsQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}






